import {
  DynamicLinkType,
  FlexibleBlockBrickSocial,
  FlexibleBlockBrickText,
  FlexibleBlockBrickTitle,
  FlexibleBlockProps,
  FlexibleBlockTemplateHeroCounsalting,
  PortalTextType,
} from '@nx-frontend/shared/types';
import { getWrapperProps } from '@nx-frontend/shared/utils/blocks';
import { brickCommon } from './common';

export const getHeroCounsaltingBlockTemplate = (): FlexibleBlockProps<FlexibleBlockTemplateHeroCounsalting>[] => {
  const brickTitle: FlexibleBlockBrickTitle = {
    ...brickCommon,
    brickType: 'title',
    brickName: 'Title',
    switchable: true,
    placeholder: 'Here, you can add title',
    text: 'Aeon Consulting',
    className: ['md:text-6xl', 'text-3xl', 'font-bold', 'text-left'],
    theme: {
      text: {
        main: PortalTextType.HERO_TEXT,
      },
    },
  };

  const brickDescription: FlexibleBlockBrickText = {
    ...brickCommon,
    brickType: 'text',
    brickName: 'Description',
    switchable: true,
    placeholder: 'Here, you can add description',
    text: 'Pioneering your path to success with Aeon Consulting, strategic solutions: empower your business journey today',
    className: ['text-lg', 'text-left'],
    theme: {
      text: {
        main: PortalTextType.HERO_TEXT,
      },
    },
  };

  const brickSocial: FlexibleBlockBrickSocial = {
    ...brickCommon,
    brickType: 'social',
    brickName: 'Social Media',
    switchable: false,
    className: [],
    items: [
      {
        show: true,
        title: 'Facebook',
        dynamicLink: {
          type: DynamicLinkType.EXTERNAL,
          url: 'https://www.facebook.com/',
        },
        icon: '/assets/img/blocks/social/icon-facebook.svg',
      },
      {
        show: true,
        title: 'Telegram',
        dynamicLink: {
          type: DynamicLinkType.EXTERNAL,
          url: 'https://telegram.org/',
        },
        icon: '/assets/img/blocks/social/icon-telegram.svg',
      },
      {
        show: true,
        title: 'X (Twitter)',
        dynamicLink: {
          type: DynamicLinkType.EXTERNAL,
          url: 'https://twitter.com/',
        },
        icon: '/assets/img/blocks/social/icon-twitter.svg',
      },
      {
        show: true,
        title: 'LinkedIn',
        dynamicLink: {
          type: DynamicLinkType.EXTERNAL,
          url: 'https://www.linkedin.com/',
        },
        icon: '/assets/img/blocks/social/icon-linkedin.svg',
      },
      {
        show: false,
        title: 'Instagram',
        dynamicLink: {
          type: DynamicLinkType.EXTERNAL,
          url: 'https://www.instagram.com/',
        },
        icon: '/assets/img/blocks/social/icon-instagram.svg',
      },
      {
        show: false,
        title: 'Reddit',
        dynamicLink: {
          type: DynamicLinkType.EXTERNAL,
          url: 'https://www.reddit.com/',
        },
        icon: '/assets/img/blocks/social/icon-reddit.svg',
      },
      {
        show: false,
        title: 'WhatsUp',
        dynamicLink: {
          type: DynamicLinkType.EXTERNAL,
          url: 'https://whatsapp.com/',
        },
        icon: '/assets/img/blocks/social/icon-whatsapp.svg',
      },
    ],
  };

  let index = 0;
  return [
    {
      title: 'Hero Consalting',
      template: { type: 'hero-counsalting', view: 'basic' },
      bricks: [
        { ...brickTitle, index: index++ },
        { ...brickDescription, index: index++ },
        { ...brickSocial, index: index++ },
      ],
      className: ['justify-around', 'min-h-64', 'text-center'],
      wrapper: getWrapperProps('none'),
    },
  ];
};
